@switch (columnName) {
  @case ('dateTime') {
    {{ element['date'] | date: dateFormat }}
  }
  @case ('action') {
    {{ element['action'] | translate }}
    @if (element.doneByMarineManager) {
      <span>({{ 'marineManager' | translate }})</span>
    }
  }
  @case ('actionDoneBy') {
    <div class="action-done-by">
      <mat-icon>perm_identity</mat-icon>
      <p class="action-done-by__text">
        {{ element['by']?.name }}
        @if (element['by']?.positionName) {
          <small>{{ element['by'].positionName }}</small>
        }
      </p>
    </div>
  }
  @case ('comment') {
    {{ element.comment || '-' }}
  }
  @case ('maintenanceJobLogDetails') {
    <div class="maintenance-job-log-details">
      @if (element.extraInfo?.length) {
        @for (info of element.extraInfo; track info) {
          <div class="field-change">
            <span class="text-secondary">{{ info }}</span>
          </div>
        }
      }
      @if (element.changes?.length) {
        @for (change of element.changes; track change.fieldName) {
          <div class="field-change">
            <span class="highlighted-text">
              {{ getFieldLabelKey(change.fieldName) | translate }}
            </span>
            <span class="text-secondary">
              @if (change.oldValue) {
                {{ 'wasMovedFrom' | translate }}
                @if (isDateChange(change.fieldName, change.oldValue)) {
                  {{ change.oldValue | date: changeDateFormat }}
                } @else {
                  {{ change.oldValue }}
                }
                {{ 'to' | translate | lowercase }}
                @if (isDateChange(change.fieldName, change.newValue)) {
                  {{ change.newValue | date: changeDateFormat }}
                } @else {
                  {{ change.newValue }}
                }
              } @else {
                {{ 'changedTo' | translate }}
                @if (isDateChange(change.fieldName, change.newValue)) {
                  {{ change.newValue | date: changeDateFormat }}
                } @else {
                  {{ change.newValue }}
                }
              }
            </span>
          </div>
        }
      }
    </div>
  }
  @case ('view') {
    @if (element.action === 'StandardPerform') {
      <app-ui-button
        buttonType="secondary"
        text="{{ 'view' | translate }}"
        [routerLink]="getPerformViewRoute()"
        [queryParams]="{ referrer: logTabReferrer }"
        queryParamsHandling="merge"
      ></app-ui-button>
    }
  }
  @case ('legacyAttachment') {
    @if (legacyAttachment; as attachment) {
      @if (attachment.id !== 'new') {
        <a [href]="attachment.link" target="_blank" [download]="attachment.name">
          <mat-icon class="download-icon">download</mat-icon>
        </a>
      }
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
